/**
 * Denetim kaydı görünümünün verisi (plan M7 Task 30; `@felix/db` `auditTrail`'in yapısal kopyası)
 * ve metin yardımcıları. ADR 0029 K37: gemide yalnız gemide yapılan değişiklikler vardır.
 */

export type AuditTrailOp =
  | 'insert'
  | 'update'
  | 'delete'
  | 'prepared_in_office'
  | 'created_in_office'
  | 'changed_in_office';

export interface AuditTrailEvent {
  id: string;
  table: string;
  rowId: string;
  op: AuditTrailOp;
  field: string | null;
  oldValue: unknown;
  newValue: unknown;
  user: { id: string | null; name: string | null };
  device: { id: string | null; name: string | null };
  matrixVersion: number | null;
  at: string;
  tzOffsetMin: number | null;
  shipTime: string | null;
  source: 'audit_log' | 'row';
}

export interface AuditTrailData {
  scope: 'ship' | 'office';
  officeHistory: boolean;
  total: number;
  events: AuditTrailEvent[];
  /** Gemide `ship_changes_only` (K37). */
  notes?: string[];
}

/** Süzgeç (`GET …/audit`): yalnız PMS tabloları; an ISO-8601 UTC. */
export interface AuditTrailFilter {
  table?: string;
  rowId?: string;
  from?: string;
  to?: string;
  user?: string;
  limit?: number;
  offset?: number;
}

/** Değerin metni: dizgi olduğu gibi, boş "—", diğerleri JSON. */
export function auditValueText(value: unknown): string {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return JSON.stringify(value);
}

/** Saat farkı `UTC±hh:mm`. */
export function offsetLabel(minutes: number): string {
  const abs = Math.abs(minutes);
  const hours = String(Math.floor(abs / 60)).padStart(2, '0');
  return `UTC${minutes < 0 ? '-' : '+'}${hours}:${String(abs % 60).padStart(2, '0')}`;
}
